import { useSearchParams, useNavigate } from "react-router";
import { Box, Paper, Stack, Typography, Alert } from "@mui/material";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { FormField, LoadingButton } from "@safrater/ui";
import { api } from "../../api/client";

interface Form { password: string; confirm: string }

export function SetupPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const form = useForm<Form>({ defaultValues: { password: "", confirm: "" } });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  if (!token) {
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
        <Paper sx={{ p: 4 }}>
          <Alert severity="error">Link inválido. Solicite um novo email de definição de senha.</Alert>
        </Paper>
      </Box>
    );
  }

  if (success) {
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom>Senha definida</Typography>
          <Typography variant="body2">Você já pode entrar com sua nova senha.</Typography>
          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <LoadingButton variant="contained" onClick={() => navigate("/login")}>Ir para o login</LoadingButton>
          </Stack>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 420, width: "100%" }}>
        <Typography variant="h5" gutterBottom>Definir senha</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Stack
          component="form"
          spacing={2}
          onSubmit={form.handleSubmit(async (data) => {
            setError(null);
            if (data.password !== data.confirm) {
              setError("As senhas não conferem");
              return;
            }
            try {
              await api.post("/auth/password/setup", { token, password: data.password });
              setSuccess(true);
            } catch (e: unknown) {
              const msg = (e as { response?: { data?: { message?: string } } })?.response?.data?.message;
              setError(msg ?? "Não foi possível definir a senha.");
            }
          })}
        >
          <FormField
            type="password"
            label="Nova senha"
            {...form.register("password", { required: "Obrigatório", minLength: { value: 10, message: "Mínimo 10 caracteres" } })}
            errorMessage={form.formState.errors.password?.message}
            helperText="Use ao menos 10 caracteres, com letras, números e símbolos."
          />
          <FormField
            type="password"
            label="Confirmar senha"
            {...form.register("confirm", { required: "Obrigatório" })}
            errorMessage={form.formState.errors.confirm?.message}
          />
          <LoadingButton type="submit" variant="contained" loading={form.formState.isSubmitting}>
            Definir senha
          </LoadingButton>
        </Stack>
      </Paper>
    </Box>
  );
}
